<template>
    <el-pagination
    :page-size="20"
    :pager-count="11"
    layout=" pager"
    :total="100">
  </el-pagination>
</template>

<script>
export default {
    
}
</script>